module.exports = __webpack_public_path__ + "static/media/bg-header.72276ca5.png";